/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const COLLECTION_TYPES = [
  'series',
  'season',
  'episode',
  'movie',
  'documentary',
  'news',
  'talk',
  'podcast',
  'music',
  'influencer',
  'teacher',
  'interview',
  'course',
  'book',
  'wordlist',
  'vocabulary',
  'quotes',
  'cefrLevel',
  'challengeType',
  'frequency',
] as const;

export const collectionTypeSchema = z.enum(COLLECTION_TYPES);

export type ICollectionType = z.infer<typeof collectionTypeSchema>;
